import React from 'react';
import PropTypes from 'prop-types';

import Badge from '../Badge';

const BadgeResySelect = ({ label, size, link }) => (
  <>
    <Badge
      name="resyselect"
      label={label}
      title="Resy Select"
      size={size}
      link={link}
    />
  </>
);

BadgeResySelect.propTypes = {
  label: PropTypes.string,
  size: PropTypes.string,
  link: PropTypes.string,
};

BadgeResySelect.defaultProps = {
  label: undefined,
  size: '22',
  link: undefined,
};

BadgeResySelect.displayName = 'BadgeResySelect';
export default BadgeResySelect;
